import script from "./UserAuthenticate.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAuthenticate.vue?vue&type=script&setup=true&lang=js"

import "./UserAuthenticate.vue?vue&type=style&index=0&id=39f0ae83&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f0ae83"]])

export default __exports__